import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { SubscriptionLike as ISubscription, Observable } from 'rxjs';
import { AuthService } from '../../../core/services/auth/auth.service';
import { DialogService } from '../../../core/services/dialog/dialog.service';
import { SpinnerService } from '../../../core/services/spinner/spinner.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { VideosService } from '../../videos/videos.service';

import { APP_SETTINGS } from '@services';
import { ToastrService } from 'ngx-toastr';
import { NoiseCatalogService } from '../noise-catalog.service';
import { NgIf, NgFor, NgClass, NgStyle, DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { HighlightSearchPipe } from '../../../shared/pipes/highlight-search.pipe';

@Component({
    selector: 'app-noise-catalog-watchlist',
    templateUrl: './noise-catalog-watchlist.component.html',
    styleUrls: ['./noise-catalog-watchlist.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        RouterLink,
        NgFor,
        NgClass,
        NgStyle,
        DatePipe,
        HighlightSearchPipe,
    ],
})
export class NoiseCatalogWatchlistComponent implements OnInit, OnDestroy {

  public screenWidth: any;
  public noisecatalogList: any;
  private subscription: ISubscription[];
  private isSaved = true;
  username: string;
  
  public dateFormat: string;

  public videoThumbnail =  APP_SETTINGS.isMINI === 'true' ? APP_SETTINGS.miniVideoThumbnail : APP_SETTINGS.isRollsRoyce === 'true' ? APP_SETTINGS.rollsRoyceVideoThumbnail :  APP_SETTINGS.videoThumbnail;
  public videoThumbnailHeight = APP_SETTINGS.videoThumbnailHeight;
  public videoThumbnailWidth = APP_SETTINGS.videoThumbnailWidth;

  APP_SETTINGS: any;
  constructor(
    private videoService: VideosService,
    private noiseCatalogService: NoiseCatalogService,
    private changeDetector: ChangeDetectorRef,
    private utilityService: UtilityService,
    private dialogService: DialogService,
    private authService: AuthService,
    private spinnerService: SpinnerService,
    // private toastService: ToastConfigService
    private toastService: ToastrService
  ) {
    // this.toasterService = toasterService;
    //this.config = this.toastService.config;
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
    this.APP_SETTINGS = APP_SETTINGS;
    this.username = this.authService.getUserName();
    this.dateFormat = 'yyyy-MM-dd';
    this.subscription = [];
    this.spinnerService.show('bmwSpinner');
    this.subscription.push(this.noiseCatalogService.getUsersWatchlist(this.username).subscribe(value => {
      this.spinnerService.hide('bmwSpinner');
      this.noisecatalogList = value;
    }));
  }
  canDeactivate(): Observable<boolean> | boolean {
    if (!this.isSaved) {
      if (this.dialogService.confirm('Discard changes?')['value'] === true) {
        //this.applyChanges();
        return true;
      }
      return false;
    }
    return true;
  }
  moveItemUp(index, video) {
    if (index > 0) {
      this.isSaved = false;
      this.noisecatalogList.splice(index, 1);
      this.noisecatalogList.splice(index - 1, 0, video);
    }
  }
  moveItemDown(index, video) {
    if (index < this.noisecatalogList.length - 1) {
      this.isSaved = false;
      this.noisecatalogList.splice(index, 1);
      this.noisecatalogList.splice(index + 1, 0, video);
    }
  }
  moveItemTop(index, video) {
    if (index > 0) {
      this.isSaved = false;
      this.noisecatalogList.splice(index, 1);
      this.noisecatalogList.splice(0, 0, video);
    }
  }
  moveItemBottom(index, video) {
    if (index < this.noisecatalogList.length - 1) {
      this.isSaved = false;
      this.noisecatalogList.splice(index, 1);
      this.noisecatalogList.splice(this.noisecatalogList.length, 0, video);
    }
  }
  transferDataSuccess(data) {
    this.isSaved = false;
  }
  applyChanges() {
    if (!this.isSaved) {

      this.isSaved = true;
      for (let i = 0; i < this.noisecatalogList.length; i++) {
        this.noisecatalogList[i]['sortingOrder'] = i + 1;
      }
      this.subscription.push(this.noiseCatalogService.saveWatchlistSortOrder(this.username, this.noisecatalogList).subscribe(value => {
        this.toastService.success('Noise Catalog watchlist saved successfully', 'Success', {
          closeButton: true,
          tapToDismiss: true,
          positionClass: 'toast-bottom-center',
          timeOut: 2000,
      });   
    
      }));
    }
    else {
      this.toastService.success('Noise Catalog watchlist saved successfully', 'Success', {
        closeButton: true,
        tapToDismiss: true,
        positionClass: 'toast-bottom-center',
        timeOut: 2000,
      });
    }  
  }
 
  removeFromWatchlist(noisecatalogId) {
    this.subscription.push(this.noiseCatalogService.removeNoiseCatalogFromWatchlist(this.username, noisecatalogId).subscribe(value => {
      this.noisecatalogList = value;
    }));
  }

  showSuccess() {
    //this.toastService.popToast('Successful message');
    // this.toastService.pop('Successful message'); FIXME this is not  used anywhere
  }

  ngOnDestroy(): void {
    this.subscription.forEach(s => s.unsubscribe());
  }

  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

}

